import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { IApplyIncrementRequest, IApplyIncrementResult, IDueForIncrement } from '../interfaces/payroll.interface';

// H-1 annual increment: who is due this year, and apply the grade increment to the ticked people.
export const WageIncrementService = {
    getDue: async (institutionId: string, asOfYear: number): Promise<IDueForIncrement[]> => {
        const response = await axios.get(ENDPOINTS.WAGE_INCREMENT.DUE(institutionId, asOfYear), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    apply: async (data: IApplyIncrementRequest): Promise<IApplyIncrementResult[]> => {
        const response = await axios.post(ENDPOINTS.WAGE_INCREMENT.APPLY, data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },
};
